import get from 'lodash/get'
import has from 'lodash/has'
import isNil from 'lodash/isNil'

import { targetGetCenter } from 'utils/target'

// import PoziFragments from 'drawer/tabs/info/fragment/fragments'

function PoziIFrame () {
  // Adapters
  const adapters = {
    /**
     * @api {NA} PoziIFrame().load Load IFrame
     * @apiDescription Load the layer iframe url into the info tab.
     * @apiGroup Fragments
     * @apiName IFrame
     *
     * @apiParam {Object} fragmentOptions Fragment and Layer
     * @apiParam {Object} fragmentOptions.fragment Fragment
     * @apiParam {Object} fragmentOptions.fragment.id Fragment ID
     * @apiParam {Object} fragmentOptions.layer Layer
     *
     * @apiSuccess {Promise} Resolve No errors
     * @apiError {Promise} Reject Error to console
     */
    load: function (fragmentOptions) {
      return load(fragmentOptions)
    }
  }

  const load = function (fragmentOptions) {
    return check(fragmentOptions)
      // .then(render) // Fragments now rendered in React
      .then(success)
      .catch(error)
  }

  const check = function (fragmentOptions) {
    return new Promise(function (resolve, reject) {
      let err = ''

      if (isNil(fragmentOptions)) {
        err = 'Invalid fragmentOptions object.'
        return reject(err)
      }

      if (!has(fragmentOptions, 'loadOptions')) {
        err = 'No loadOptions object.'
        return reject(err)
      }

      if (!has(fragmentOptions, 'fragment')) {
        err = 'No fragment object.'
        return reject(err)
      }

      if (!has(fragmentOptions, 'fragment.style')) {
        fragmentOptions.fragment.style = ''
      }

      const loadOptions = fragmentOptions.loadOptions
      const fragment = fragmentOptions.fragment

      if (isNil(loadOptions)) {
        err = 'Invalid loadOptions object.'
        return reject(err)
      }

      if (!has(loadOptions, 'layer')) {
        err = 'Must include loadOptions.layer.'
        return reject(err)
      }

      if (!has(loadOptions, 'titleid')) {
        err = 'Must include loadOptions.titleid.'
        return reject(err)
      }

      if (!has(loadOptions, 'featureid')) {
        err = 'Warning: does not include a loadOptions.featureid.'
        console.log(err)
      }

      if (get(fragment, 'url', '') === '') {
        err = 'No fragment URL found.'
        return reject(err)
      }

      const targetCenter = targetGetCenter()
      if (isNil(targetCenter)) {
        err = 'Warning: No point found.'
        console.log(err)
      } else {
        if (!has(targetCenter, 'geometry.coordinates[0]')) {
          err = 'Invalid target geojson! Must be a point type.'
          return reject(err)
        }

        if (!has(targetCenter, 'geometry.coordinates[1]')) {
          err = 'Invalid target geojson! Must be a point type.'
          return reject(err)
        }

        // E.g. https://form.jotform.co/80227823138859?longitude=[lng]&latitude=[lat]&layerId=[layerid]&featureId=[featureid]
        fragment.lng = Math.round(targetCenter.geometry.coordinates[0] * 1000000) / 1000000
        fragment.urlSrc = fragment.url.replace('[lng]', fragment.lng)

        fragment.lat = Math.round(targetCenter.geometry.coordinates[1] * 1000000) / 1000000
        fragment.urlSrc = fragment.urlSrc.replace('[lat]', fragment.lat)

        fragment.urlSrc = fragment.urlSrc.replace('[layerid]', loadOptions.titleid)
        fragment.urlSrc = fragment.urlSrc.replace('[featureid]', loadOptions.featureid)
      }

      return resolve(fragmentOptions)
    })
  }

  const success = function (fragmentOptions) {
    // console.debug('IFrame load success.', fragmentOptions)

    return fragmentOptions
  }

  const error = function (err) {
    console.log('IFrame load failed.', err)
    throw err
  }

  // Return adapters (must be at end of adapter)
  return adapters
}

export default PoziIFrame
// End A (Adapter)
